import {
  DEFAULT_BLACK_IMAGE_PATH,
} from '../../../scripts/Routes/images.js';

export const movies = {
  '2024': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Poor Things',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Wonka',
      'url': '#',
    },
  ],
  '2023': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Banshees of Inisherin',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Titanic (Dolby Cinema)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Women Talking',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Whale',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Babylon',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Avatar: The Way of Water',
      'url': '#',
    },
  ],
  '2022': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Matrix 4',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Spiderman',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Thank you for smoking',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Royal Tenenbaums',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Batman',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Super Pumped',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Secrets of Dumbledore',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'WeCrashed (TV)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Top Gun 2',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Bill Burr Presents: Friends Who Kill',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Hall: Honoring the Greats of Stand-Up',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Oceans documentary',
      'theater': 'valencia',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Fablemans',
      'url': '#',
    },
  ],
  '2021': [
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Grand Budapest Hotel',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Final Shot',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Into the Wild (In Progress)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Tony Parker Documentary',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Trial of the Chicago 7',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Fury',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Licoln Lawyer',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Little Things',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Days of Thunder',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Risky Business',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Once Upon a Time in Mexico',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Bill and Ted (1,2,3)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Play of State',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Billions (TV)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': '(TV) Master of None Season 3',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Dune',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'James Bond: No Time to Die',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Magnolia',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The French Dispatch',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Constantine',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'What Women Want',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Official Secrets',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'The Closer',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Untitled Documentary',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Hangover (1,2,3)',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Dog Day Afternoon',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Team America: World Police',
      'url': '#',
    },
    {
      'src': DEFAULT_BLACK_IMAGE_PATH,
      'text': 'Lincoln Lawyer',
      'url': '#',
    },
  ],
};
